
(() => {
'use strict';

const SB='https://xlqqqklbfzxduqqmbnxd.supabase.co';
const KEY='sb_publishable_0Ti6F0HzOJSBj8OS9lsmvQ_sQBSzeWJ';
const SESSION_KEY='seven_supabase_session_v32';

const RANKS=[
  {n:'E',min:0,max:599,c:'#8b8e98'},
  {n:'D',min:600,max:1749,c:'#4d8cff'},
  {n:'C',min:1750,max:3599,c:'#3ed0a0'},
  {n:'B',min:3600,max:6499,c:'#b66cff'},
  {n:'A',min:6500,max:10999,c:'#ffb454'},
  {n:'S',min:11000,max:17499,c:'#ff334d'},
  {n:'S1',min:17500,max:26999,c:'#ff284d'},
  {n:'S2',min:27000,max:40999,c:'#ff754f'},
  {n:'S3',min:41000,max:62499,c:'#ffd36a'},
  {n:'MASTER',min:62500,max:94999,c:'#f2c66d'},
  {n:'ELITE',min:95000,max:149999,c:'#eaf2ff'},
  {n:'LEGEND',min:150000,max:Infinity,c:'#ffd760'}
];

const session=()=>{try{return JSON.parse(localStorage.getItem(SESSION_KEY)||'null')}catch(e){return null}};
const uid=()=>session()?.user?.id||null;
const q=s=>document.querySelector(s);
const qa=s=>[...document.querySelectorAll(s)];
const set=(s,v)=>{const el=q(s);if(el)el.textContent=v};
const rankFor=xp=>RANKS.find(r=>xp>=r.min&&xp<=r.max)||RANKS[0];
const nextRank=r=>RANKS[Math.min(RANKS.indexOf(r)+1,RANKS.length-1)];

async function api(path,opt={}){
  const s=session();
  if(!s?.access_token)throw new Error('Session expirée. Reconnecte-toi.');
  const r=await fetch(SB+path,{
    cache:'no-store',
    mode:'cors',
    credentials:'omit',
    ...opt,
    headers:{apikey:KEY,Authorization:'Bearer '+s.access_token,...(opt.headers||{})}
  });
  const txt=await r.text();
  let d=null;try{d=txt?JSON.parse(txt):null}catch(e){d=txt}
  if(!r.ok)throw new Error(d?.message||d?.error||txt||('Erreur '+r.status));
  return d;
}

async function profile(){
  try{
    const d=await api('/rest/v1/seven_profiles?id=eq.'+encodeURIComponent(uid())+'&select=*');
    return d?.[0]||null;
  }catch(e){return null}
}

function previewPack(p){
  const sim=q('[data-seven-sim-access]')?.value||'';
  if(sim.includes('silver'))return 'silver';
  if(sim.includes('gold'))return 'gold';
  if(sim.includes('diamond')||sim==='full')return 'diamond';
  const raw=String(p?.pack||p?.trading_pack||'silver').toLowerCase();
  return ['silver','gold','diamond'].includes(raw)?raw:'silver';
}

function firstName(p,user){
  const raw=String(p?.first_name||p?.firstname||p?.prenom||p?.full_name||p?.name||'').trim();
  if(raw)return raw.split(/\s+/)[0];
  const local=(user?.email||'').split('@')[0]
    .replace(/[0-9]+/g,'')
    .replace(/[._-]+/g,' ')
    .trim();
  return local ? local.split(/\s+/)[0].replace(/\b\w/g,x=>x.toUpperCase()) : 'Élève';
}

async function syncCompleted(){
  try{
    return await api('/rest/v1/rpc/sync_completed_resource_xp',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:'{}'
    });
  }catch(e){
    console.warn('SEVEN V55 sync:',e.message);
    return null;
  }
}

async function xpTotal(){
  if(window.SevenServerProgressState && Number.isFinite(Number(window.SevenServerProgressState.xp))){
    return Number(window.SevenServerProgressState.xp);
  }
  if(window.sevenSyncProgressFromServer)await window.sevenSyncProgressFromServer();
  if(window.SevenServerProgressState)return Number(window.SevenServerProgressState.xp||0);
  return 0;
}

function levelData(xp){
  const level=Math.max(1,Math.floor(xp/500)+1);
  const levelStart=(level-1)*500;
  const levelEnd=level*500;
  const within=xp-levelStart;
  const pct=Math.max(0,Math.min(100,Math.round(within/500*100)));
  return {level,levelStart,levelEnd,within,pct};
}

function rankData(xp){
  const r=rankFor(xp), nr=nextRank(r);
  const pct=r.max===Infinity
    ? 100
    : Math.max(0,Math.min(100,Math.round((xp-r.min)/(r.max-r.min+1)*100)));
  const need=r.max===Infinity?0:r.max+1-xp;
  return {r,nr,pct,need};
}

function animateXP(amount){
  if(!amount)return;

  const toast=document.createElement('div');
  toast.className='seven-xp-earned-v53';
  toast.innerHTML='<span>PROGRESSION SYNCHRONISÉE</span><b>+'+amount+' XP</b>';
  document.body.appendChild(toast);
  requestAnimationFrame(()=>toast.classList.add('is-open'));

  const target=q('[data-seven-mini-xpbar]')||q('[data-v51-xpbar]');
  const tr=target?.getBoundingClientRect();

  if(tr){
    for(let i=0;i<12;i++){
      const star=document.createElement('i');
      star.className='seven-xp-star-v53';
      star.textContent='✦';
      star.style.left=(window.innerWidth/2+(Math.random()-.5)*160)+'px';
      star.style.top=(window.innerHeight*.34+(Math.random()-.5)*80)+'px';
      document.body.appendChild(star);

      requestAnimationFrame(()=>{
        star.style.transform=`translate(${tr.left-window.innerWidth/2}px,${tr.top-window.innerHeight*.34}px) scale(.2)`;
        star.style.opacity='0';
      });
      setTimeout(()=>star.remove(),1000);
    }
  }

  setTimeout(()=>{
    toast.classList.remove('is-open');
    setTimeout(()=>toast.remove(),280);
  },2200);
}

function showRankUp(r){
  const o=q('[data-seven-rankup-v52]');
  if(!o)return;

  set('[data-v52-rankup-rank]',r.n);
  set('[data-v52-rankup-copy]','Nouveau rang atteint : Rang '+r.n+'.');
  q('[data-v52-rankup-rank]')?.style.setProperty('--rank-color',r.c);

  o.classList.remove('seven-fire-rank-s');
  if(r.n==='S')o.classList.add('seven-fire-rank-s');
  o.classList.add('seven-fire-event');

  o.hidden=false;
  requestAnimationFrame(()=>o.classList.add('is-open'));

  const close=o.querySelector('[data-v52-rankup-close]');
  if(close){
    close.onclick=()=>{
      o.classList.remove('is-open');
      setTimeout(()=>{
        o.hidden=true;
        o.classList.remove('seven-fire-event','seven-fire-rank-s');
      },350);
    };
  }
}

function showLevelUp(level){
  let o=q('[data-seven-levelup-v81]');

  if(!o){
    o=document.createElement('div');
    o.className='seven-levelup-v81';
    o.setAttribute('data-seven-levelup-v81','');
    o.hidden=true;
    o.innerHTML=`
      <div class="seven-levelup-v81__core">
        <span>SEVEN SYSTEM</span>
        <small>NIVEAU SUPÉRIEUR ATTEINT</small>
        <h2>LEVEL UP</h2>
        <b data-seven-levelup-number>LVL ${level}</b>
        <p>Ta progression vient d’atteindre un nouveau palier.</p>
        <button type="button" data-seven-levelup-close>CONTINUER →</button>
      </div>
    `;
    document.body.appendChild(o);
  }

  q('[data-seven-levelup-number]',o).textContent='LVL '+level;
  o.classList.add('seven-fire-event');
  o.hidden=false;

  requestAnimationFrame(()=>o.classList.add('is-open'));

  const close=q('[data-seven-levelup-close]',o);
  if(close){
    close.onclick=()=>{
      o.classList.remove('is-open');
      setTimeout(()=>{
        o.hidden=true;
        o.classList.remove('seven-fire-event');
      },320);
    };
  }
}


async function renderAuthoritative({animateRank=false}={}){
  const s=session();
  if(!s?.user)return;

  const [p,xp]=await Promise.all([profile(),xpTotal()]);
  const pack=previewPack(p);
  const first=firstName(p,s.user);
  const ld=levelData(xp);
  const rd=rankData(xp);

  // Dashboard personal
  set('[data-v51-firstname]',first.toUpperCase()+'.');
  set('[data-v51-pack]',pack.toUpperCase());
  set('[data-v51-level]',ld.level);
  set('[data-v51-grade]',rd.r.n);
  set('[data-v51-grade-big]',rd.r.n);
  set('[data-v51-xp]',xp+' XP');
  set('[data-v51-grade-copy]','Rang '+rd.r.n+' — progression SEVEN');
  set('[data-v51-next-grade]',rd.r.n==='LEGEND'?'RANG LEGEND — MAXIMUM':rd.need+' XP avant le Rang '+rd.nr.n);
  set('[data-v51-next-grade-name]',rd.r.n==='LEGEND'?'RANG LEGEND':'RANG '+rd.nr.n);
  set('[data-v51-next-grade-message]',rd.r.n==='LEGEND'?'Tu as atteint le rang maximum du système SEVEN.':'Encore '+rd.need+' XP avant le Rang '+rd.nr.n+'.');
  set('[data-v51-grade-percent]',rd.pct+'%');
  q('[data-v51-xpbar]')?.style.setProperty('width',ld.pct+'%');
  q('[data-v51-grade]')?.style.setProperty('color',rd.r.c);
  q('[data-v51-grade-big]')?.style.setProperty('color',rd.r.c);

  // FLOATING/STICKY BAR — exact real markup
  qa('[data-seven-mini-pack]').forEach(el=>el.textContent=pack.toUpperCase());
  qa('[data-seven-mini-level]').forEach(el=>el.textContent=ld.level);
  qa('[data-seven-mini-xp]').forEach(el=>el.textContent=xp);
  qa('[data-seven-mini-next]').forEach(el=>el.textContent=ld.levelEnd);
  qa('[data-seven-mini-xpbar]').forEach(el=>el.style.width=ld.pct+'%');

  // Other legacy panels that may still exist
  qa('[data-seven-real-xp]').forEach(el=>el.textContent=xp);
  qa('[data-seven-xp]').forEach(el=>el.textContent=xp);
  qa('[data-seven-level]').forEach(el=>{
    const old=el.textContent||'';
    el.textContent=/NIVEAU/i.test(old)?'NIVEAU '+ld.level:String(ld.level);
  });
  qa('[data-seven-xpbar]').forEach(el=>el.style.width=ld.pct+'%');

  // Persist only a harmless local cache for immediate paint; Supabase remains truth.
  localStorage.setItem('seven_v55_cached_xp',String(xp));

  // V81: localStorage is display cache only, never animation authority.
  localStorage.setItem('seven_v55_last_rank',rd.r.n);

  return {xp,pack,level:ld.level,rank:rd.r.n};
}

async function fullSync({animate=true}={}){
  // XP before server synchronization. This is the only transition baseline.
  const before=Number(localStorage.getItem('seven_v55_cached_xp')||0);
  const beforeLevel=levelData(before).level;
  const beforeRank=rankData(before).r;

  const result=await syncCompleted();
  const state=await renderAuthoritative({animateRank:false});

  if(!state)return;

  const after=Number(state.xp||0);
  const afterLevel=levelData(after).level;
  const afterRank=rankData(after).r;
  const awarded=Number(result?.awarded||0);
  const gained=Math.max(0,after-before);

  if(animate && (awarded>0 || gained>0)){
    animateXP(awarded>0?awarded:gained);
  }

  // V157: Level/Rank visuals are event-driven exclusively by V61 -> V142.
  // V55 only synchronizes XP and its small XP toast; no legacy full-screen overlay here.

  // If the test was reset to zero, synchronize local level/rank caches too.
  if(after===0){
    localStorage.setItem('seven_v74_level','1');
    localStorage.setItem('seven_v55_last_rank','E');
    localStorage.setItem('seven_v52_last_rank','E');
  }
}

// Initial synchronization.
document.addEventListener('DOMContentLoaded',()=>{
  setTimeout(()=>fullSync({animate:true}),500);

  // Founder pack simulation changes.
  q('[data-seven-sim-access]')?.addEventListener('change',()=>{
    setTimeout(()=>renderAuthoritative({animateRank:false}),80);
  });

  // Resource updates from admin/student.
  document.addEventListener('seven:resources-changed',()=>{
    setTimeout(()=>fullSync({animate:true}),250);
  });

  // When returning to the tab, resync from server.
  document.addEventListener('visibilitychange',()=>{
    if(!document.hidden)setTimeout(()=>fullSync({animate:false}),120);
  });

  // Resource click: PDFs are completed by V48.
  // Run a server sync after the progress row has had time to save.
  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-v48-open]');
    if(!btn)return;
    setTimeout(()=>fullSync({animate:true}),1400);
  });

  // Periodically correct any legacy script that tries to rewrite the mini bar.
});

// Global hook usable by video / quiz / quests later.
window.sevenSyncProgressFromServer=()=>fullSync({animate:true});

})();
